interface FrameSize { width: number; height: number }
interface PreviewStage extends FrameSize { fitWidth?: boolean }

/** Stacked previews use their full width; bounded stages contain the complete frame. */
export function previewFrameScale(frame: FrameSize, stage: PreviewStage, fitStage = true): number {
  const widthScale = Math.max(0, stage.width) / frame.width;
  if (fitStage && stage.fitWidth) return widthScale;
  return Math.min(widthScale, Math.max(0, fitStage ? stage.height : 560) / frame.height);
}
